// config
import * as http from 'utils/http';
import config from 'config';

const moveTicketToTMS = async ({ id, orderIdDTO }) => {
  return http.post(`${config.API_URL}price-negotiation/tickets/${id}/completions/`, orderIdDTO);
};

export default moveTicketToTMS;
